import type { UploadFn } from "./upload";

export * from "./types";

const getUploadImpl = () => import("./upload");

// can be used to prefetch the upload implementation if you know you're going to need it
export const prefetch = async () => {
  await getUploadImpl();
};

export async function upload(...args: Parameters<UploadFn>) {
  const { upload: doUpload } = await getUploadImpl();
  return doUpload(...args);
}
